
<form [formGroup]="reportFieldsServices" (ngSubmit)="save()">
 
<div class="container">
  <div class="close-btn-fill-area" mat-dialog-close>
    <span class="close-btn">
    </span>
</div>
    
 <p class="title">{{'TITLE_REPORT_FIELD' | translate}}</p>

 <p class="subtitle">{{'SUBTITLE_REPORT_FIELD' | translate}}</p>

 <p class="subsubtitle">{{'SUBSUBTITLE_REPORT_FIELD' | translate}}</p>

 <label>{{'REASONS_REPOT_FIELD' | translate}}:</label>
 <mat-form-field appearance="outline" color="white" class="matformSelect">
   
   <mat-select formControlName="reason" (selectionChange)="checkValue($event.source.triggerValue)">
     
     <mat-option *ngFor="let option of arrayReasons" [value]="option.id">{{option.name}}</mat-option>
    
   </mat-select>
   <mat-error *ngIf="reportFieldsServices.get('reason').hasError('required')">
    
</mat-error>
 </mat-form-field>

 
 <p class="otherReportDescription">{{'LEYEND_REPORT_FIELD' | translate}}</p>

 <mat-form-field class="full-width" appearance="outline">
    <mat-label class="reportDescription">{{'OTHEN LEYEND_REPORT_FIELD' | translate}}</mat-label>
    <textarea matInput readonly="{{IsReadonly}}"></textarea>
  </mat-form-field>

  <table class="full-width"  cellspacing="0"><tr>
    <td>
        <button class="matbtnTransparent" mat-stroked-button (click)="close()">
          
            {{ 'DIALOG_BACK_CANCEL' | translate}}
            
        </button>
    </td>
    <td>
        <button mat-raised-button color="primary">
          <span class="continue-ico-btn"></span>
            {{ 'SEND_REPORT' | translate}}
            
        </button>
    </td>
  </tr></table>

</div>
</form>